import React from 'react';
import { Container, Typography, Paper, Box, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import FileUpload from '../../components/documents/FileUpload';

const UploadDocument: React.FC = () => {
  const navigate = useNavigate();
  const { canCreateQuizzes } = useAuth();

  // Check permission - only admin and teacher can upload documents
  if (!canCreateQuizzes()) {
    return (
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
          <Alert severity="error">
            <Typography variant="h6" gutterBottom>
              Không có quyền truy cập
            </Typography>
            <Typography>
              Bạn không có quyền upload tài liệu. Chỉ Admin và Teacher mới có thể thực hiện chức năng này.
            </Typography>
          </Alert>
        </Paper>
      </Container>
    );
  }

  const handleUploadSuccess = (response: any) => {
    console.log('Upload success response:', response);

    // Navigate to the document detail page if we have a document ID
    const documentId = response?.document?.id || response?.document_id;
    console.log('Document ID for navigation:', documentId);

    if (documentId) {
      console.log(`Navigating to /documents/${documentId}`);
      navigate(`/documents/${documentId}`);
    } else {
      console.log('No document ID, navigating to /documents');
      navigate('/documents');
    }
  };

  const handleUploadError = (error: any) => {
    console.error('Upload error:', error);
    // Additional error handling logic can be added here
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Tải lên tài liệu
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Tải lên tài liệu của bạn ở định dạng PDF, Word, Hình ảnh hoặc Văn bản. Hệ thống sẽ phân tích nội dung và tự động tạo câu hỏi.
          Bạn có thể cấu hình số lượng câu hỏi và mức độ khó (Dễ, Trung bình, Khó) trước khi tải lên.
        </Typography>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            <strong>Lưu ý:</strong> Chỉ được phép upload file tối đa 10 file, tổng dung lượng không quá 2MB. Vui lòng kiểm tra kích thước file trước khi tải lên.
          </Typography>
        </Alert>

        <Box sx={{ mt: 3 }}>
          <FileUpload
            onUploadSuccess={handleUploadSuccess}
            onUploadError={handleUploadError}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default UploadDocument; 